import React from 'react';
import EventEmitter from '../../components/modules/event-emitter/EventEmitter';
import Listener from '../../const/Listener';

class TudoAzulPage extends React.Component {
  componentDidMount() {
    this.updatePage();
  }

  componentDidUpdate() {
    this.updatePage();
  }

  updatePage() {
    EventEmitter.emitEvent(Listener.UPDATE_HEADER);
  }

  render() {
    return this.props.children;
  }
}

export default TudoAzulPage;



// WEBPACK FOOTER //
// ./src/page/tudoAzulPage/TudoAzulPage.jsx